import { render, staticRenderFns } from "./MedicationAllergies.vue?vue&type=template&id=7b97dfbc"
import script from "./MedicationAllergies.vue?vue&type=script&lang=js"
export * from "./MedicationAllergies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports